var
  Path = require('./Path/Path');

module.exports = caster;

function caster(path) {
  return new Path(path).getBoundingBox();
}

caster.Path = Path;


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-path-bounding-box/lib/caster.js
// module id = 698
// module chunks = 0